export const GET_REQUIREMENT_SUBMISSIONS = `
	query 
        requirement_submissions($status: RequirementStatus!, $pageOptions: getPageOptionsInput) {
            requirement_submissions(status: $status, pageOptions: $pageOptions){
                success
                errorText
                data {
                id
                client_id
                pass_id
                pass_category
                type_specific_data
                full_name
                creator_full_name
                creator_mobile
                creator_country_code
                user_language
                requirements {
                    id
                    title
                    type
                    submitted_data
                    form_data
                    status
                    requires_expiration
                    rejection_reason
                    reviewed_expiration_date
                    conditional_check
                    conditional_question
                    conditional_declined_at
                    previous_form_data
                    previous_submitted_data
                    custom_fields_schema {
                        id
                        type
                        label
                        column_name
                    }
                    approvals {
                        user_id
                        approved_at
                    }
                }
                status
                created_at
                }
                pagination {
                    totalCount
                    currentPage
                    totalPages
                    hasNextPage
                    hasPreviousPage
                    itemsPerPage
                }
            }
        }
`

export const UPDATE_REQUIREMENT_SUBMISSION = `
  mutation upsert_requirement_submission($data: CreateRequirementSubmissionInput!) {
    upsert_requirement_submission(input: $data) {
      success
      errorText
      errorCode
      asset_pass_warnings
      data {
        id
        pass_id
        requirements {
          id
          type
          submitted_data
          status
          rejection_reason
          approved_at
          user_id
          conditional_check
          conditional_question
          conditional_declined_at
          custom_fields_schema {
            id
            type
            label
            column_name
          }
          approvals {
            user_id
            approved_at
          }
          expiration_date
          reviewed_expiration_date
        }
        status
      }
    }
  }
`

export const FIND_APPROVED_LOGS = `
  query 
    find_approved_logs($filters: GetApprovedLogsFilterInput, $pageOptions: getPageOptionsInput) {
      find_approved_logs(filters: $filters, pageOptions: $pageOptions){
          success
          errorText
          data {
            id
            c_id
            pass_id
            pass_first_name
            pass_last_name
            requirements {
                id
                title
                content
                type
                expiration_date
                reviewed_expiration_date
                submitted_data
                submission_id
                user_id
                user_full_name
                approved_at
                conditional_mark
                conditional_check
                conditional_question
                conditional_declined_at
                custom_fields_schema {
                  id
                  type
                  label
                  column_name
                }
                delete_file_on_expiry
                identification_document
                requires_physical_verification
                approvals {
                  user_id
                  approved_at
                }
            }
          created_at
          }
          pagination {
              totalCount
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
              itemsPerPage
          }
      }
  }
`
